import {Component} from '@angular/core';
/**
 * \@title Select in a form
 */
export class SelectFormExample {
  selectedValue: string;

  foods = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'}
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'select-form-example',
  templateUrl: 'select-form-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SelectFormExample_tsickle_Closure_declarations() {
/** @type {?} */
SelectFormExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SelectFormExample.ctorParameters;
/** @type {?} */
SelectFormExample.prototype.selectedValue;
/** @type {?} */
SelectFormExample.prototype.foods;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
